$(function() {
var currentIndex = 0

// Get the modal
var modal = document.getElementById("myModal")

// Get the button that opens the modal
var galleryImages = document.getElementsByClassName("gallery__Image")

// Add click event to show modal on each image click
Array.prototype.forEach.call(galleryImages, function(gi, index) {
  gi.onclick = function() {
    currentIndex = index
    modal.style.display = "block"
    populateModal("")
  }
})

// The x that closes the modal
var x = document.getElementsByClassName("close")[0]
x.onclick = function() {
  modal.style.display = "none"
}

// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
  if (event.target == modal) {
    modal.style.display = "none"
  }
}


// Some vars to get things going
var $image = $("#myModal #image")
var $name = $("#myModal #name")
var $title = $("#myModal #title")
var $description = $("#myModal #description")
var $instagramlink = $("#myModal #instagramlink")
var $galleryItems = $(".gallery-item")
var hunnitPercent = "25%"
var negativeHunnitPercent = "-25%"
  
function populateModal(direction) {
  var lol =  $galleryItems.get(currentIndex)
  var fadeoutDirection = negativeHunnitPercent
  var fadeinDirection = hunnitPercent
  if (direction == 'left') {
    fadeoutDirection = hunnitPercent
    fadeinDirection = negativeHunnitPercent
  }

  if (direction) {
    $image.animate({'margin-left' : fadeoutDirection, 'opacity' : '0'}, 165, function() {
      $image.css({"margin-left": fadeinDirection})
      $image.attr("src",lol.dataset.image)
      $image.animate({'margin-left': 0, 'opacity': '1' }, 165)
    })

    $name.animate({'margin-left' : fadeoutDirection, 'opacity' : '0'}, 165, function() {
      $name.css("margin-left", fadeinDirection)
      $name.text(lol.dataset.name)
      $name.animate({'margin-left': 0, 'opacity': '1' }, 165)
    })
    
    $title.animate({'margin-left' : fadeoutDirection, 'opacity' : '0'}, 165, function() {
      $title.css("margin-left", fadeinDirection)
      $title.text(lol.dataset.title)
      $title.animate({'margin-left': 0, 'opacity': '1' }, 165)
    })
    
    $description.animate({'margin-left' : fadeoutDirection, 'opacity' : '0'}, 165, function() {
      $description.css("margin-left", fadeinDirection)
      $description.text(lol.dataset.description)
      $description.animate({'margin-left': 0, 'opacity': '1', width: '100%' }, 165)
    })
    
    $instagramlink.animate({'margin-left' : fadeoutDirection, 'opacity' : '0'}, 165, function() {
      $instagramlink.css("margin-left", fadeinDirection)
      $instagramlink.text("@" + lol.dataset.instagramlink)
      $instagramlink.attr("href", "https://www.instagram.com/" + lol.dataset.instagramlink)
      $instagramlink.animate({'margin-left': 0, 'opacity': '1' }, 165)
    })
  } else {
    $image.attr("src",lol.dataset.image)
    $name.text(lol.dataset.name)
    $title.text(lol.dataset.title)
    $description.text(lol.dataset.description)
    $instagramlink.text("@" + lol.dataset.instagramlink)
    $instagramlink.attr("href", "https://www.instagram.com/" + lol.dataset.instagramlink)
  }
}

/* Next button */
$("#myModal .right").click(function() {
  if (currentIndex == $galleryItems.length - 1)
    currentIndex = 0
  else
    currentIndex += 1

  populateModal('right')
})

/* Prev button */
$("#myModal .left").click(function() {
  if (currentIndex == 0)
    currentIndex = $galleryItems.length - 1
  else
    currentIndex -= 1

  populateModal('left')
})

})